import { Timestamp } from '@angular/fire/firestore';

export class BaseModel {
  created: Timestamp = Timestamp.now();
  updated: Timestamp = Timestamp.now();
}
